/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';

export const updateUserStatus = (value) => ({ //this action updates a property of the currently selected content
    type: UPDATE_USER_STATUS,
    value
});
